import React from 'react';
import Landing from './Landing';
import './App.css';

export default function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}
